/** Cold auth restoration must settle before a protected route can redirect. */
export function shouldRedirectFromAdmin(authLoading: boolean, allowed: boolean): boolean {
  return !authLoading && !allowed;
}
